module.exports = __webpack_public_path__ + "static/media/ozempic_collage.6d9eda3d.webp";